import './style.modules.scss'

import React from 'react'
import xss from 'xss'

import { SiteNavAnalytics } from '../../lib/helpers/SiteNavAnalytics'
import { Link } from '../../types/Link.type'

export type FooterDisclaimerProps = {
  links: Link[]
  userAgreeTerms: string
  rightsReserved: string
  testId?: string
}

export const FooterDisclaimer = (props: FooterDisclaimerProps) => {
  const { links, rightsReserved, userAgreeTerms, testId } = props
  const year = new Date().getFullYear()

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    try {
      const footerAnalytics = new SiteNavAnalytics()
      footerAnalytics.ping(event.currentTarget.text, 'footer')
    } catch {
      console.log('Footer analytics ping failed')
    }
  }

  return (
    <div
      className="FooterDisclaimer u-bgColorStone"
      data-testid={testId ? testId : undefined}
    >
      <div className="u-sizeConstrained u-flex u-flexCol u-textSolid">
        <div className="Grid Grid--withGutter u-md-flexCol u-sm-flexCol u-paddingVert20 u-flexNoWrap">
          {links.map((link, index) => (
            <div
              key={index}
              className={`u-lg-sizeFit u-size6of6 u-marginVert8 u-flex u-flexAlignItemsCenter ${
                index !== links.length - 1 ? 'u-borderColorNeutral50' : ''
              }`}
            >
              <a
                className="u-textColorNeutralGrey"
                href={xss(link.url)}
                dangerouslySetInnerHTML={{ __html: xss(link.name) }}
                data-testid={testId ? `${testId}-link-${index}` : undefined}
                onClick={handleClick}
              />
            </div>
          ))}
        </div>
        <p className="u-textColorNeutralGrey u-paddingTop0 u-paddingBottom16 u-lg-paddingVert16 u-textSizeMsrm1">
          {userAgreeTerms}
        </p>
        <p
          className="u-textColorNeutralGrey u-paddingBottom32 u-textSizeMsrm1"
          data-testid={testId ? `${testId}-rights-reserved` : undefined}
        >
          © <span>{year}</span> {rightsReserved}
        </p>
      </div>
    </div>
  )
}
